import type { SVGProps } from 'react';

const Verified = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height={211}
    viewBox="0 0 212 211"
    width={212}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <clipPath id="a">
      <path d="m0 0h212v211h-212z" />
    </clipPath>
    <mask id="b" height={211} maskUnits="userSpaceOnUse" width={212} x={0} y={0}>
      <path d="m0 0h212v211h-212z" fill="#fff" />
    </mask>
    <mask id="c" height={110} maskUnits="userSpaceOnUse" width={112} x={51} y={50}>
      <path
        d="m107.999 50h-1c-30.3757 0-55 24.6243-55 55 0 30.376 24.6243 55 55 55h1c30.376 0 55-24.624 55-55 0-30.3757-24.624-55-55-55z"
        fill="#fff"
      />
    </mask>
    <g clipPath="url(#a)">
      <g mask="url(#b)">
        <path
          d="m106.5 202c53.295 0 96.5-43.205 96.5-96.5 0-53.2955-43.205-96.5-96.5-96.5-53.2955 0-96.5 43.2045-96.5 96.5 0 53.295 43.2045 96.5 96.5 96.5z"
          fill="#f1f7f8"
        />
        <path
          d="m107.999 49.001h-1c-30.9279 0-56 25.072-56 56s25.0721 56 56 56h1c30.928 0 56-25.072 56-56s-25.072-56-56-56z"
          fill="#fff"
        />
        <path
          d="m107.999 50.001h-1c-30.3757 0-55 24.6243-55 55 0 30.376 24.6243 55 55 55h1c30.376 0 55-24.624 55-55 0-30.3757-24.624-55-55-55z"
          stroke="#043863"
          strokeWidth={2}
        />
        <g mask="url(#c)">
          <path
            d="m99.603 165.49h-14.605v-43.06l-12.429 9.48 8.8 10.976c1.5113 1.505 2.366 3.548 2.3777 5.681s-.8205 4.184-2.3152 5.706-3.5306 2.391-5.6636 2.418c-2.1331.027-4.1903-.79-5.7229-2.274l-12.599-19.747c-.8312-.817-1.476-1.803-1.8902-2.893-.4142-1.089-.588-2.255-.5094-3.417.0785-1.163.4075-2.295.9645-3.318.5569-1.024 1.3286-1.915 2.2621-2.612l21.718-19.982c.989-.742 2.1357-1.245 3.351-1.471.0138-.024.0334-.045.0569-.06s.0503-.024.0781-.026h.443c.6-.067 6.654-.373 7.25-.306l16.09.209 16.088-.207c.6-.067 6.65.239 7.25.306h.443c.028.002.055.011.078.025.024.015.044.035.058.059 1.215.226 2.362.73 3.351 1.471l21.717 19.982c.934.697 1.705 1.588 2.262 2.612.557 1.023.886 2.155.965 3.318.078 1.162-.096 2.328-.51 3.417-.414 1.09-1.059 2.076-1.89 2.893l-12.597 19.747c-.757.744-1.653 1.331-2.637 1.728-.985.398-2.037.597-3.098.588-1.062-.01-2.111-.228-3.087-.643-.977-.415-1.863-1.018-2.606-1.776-.744-.757-1.331-1.653-1.729-2.637-.397-.984-.597-2.037-.587-3.098.009-1.061.228-2.11.643-3.087s1.018-1.862 1.775-2.606l8.8-10.976-12.429-9.48v43.06z"
            fill="#d3e5e7"
            stroke="#054b54"
            strokeWidth={2}
          />
          <path
            d="m79.5 160.001c5.2467 0 9.5-4.253 9.5-9.5s-4.2533-9.5-9.5-9.5-9.5 4.253-9.5 9.5 4.2533 9.5 9.5 9.5z"
            fill="#fff"
          />
          <path
            d="m79.5 159.001c4.6944 0 8.5-3.806 8.5-8.5s-3.8056-8.5-8.5-8.5-8.5 3.806-8.5 8.5 3.8056 8.5 8.5 8.5z"
            stroke="#054b54"
            strokeWidth={2}
          />
          <path
            d="m135.936 160.275c5.396 0 9.77-4.374 9.77-9.77s-4.374-9.77-9.77-9.77-9.77 4.374-9.77 9.77 4.374 9.77 9.77 9.77z"
            fill="#fff"
          />
          <path
            d="m135.936 159.275c4.844 0 8.77-3.926 8.77-8.77s-3.926-8.77-8.77-8.77-8.77 3.926-8.77 8.77 3.926 8.77 8.77 8.77z"
            stroke="#054b54"
            strokeWidth={2}
          />
        </g>
        <path
          d="m108.5 94.002c10.217 0 18.5-8.2828 18.5-18.5 0-10.2173-8.283-18.5-18.5-18.5-10.2173 0-18.5 8.2827-18.5 18.5 0 10.2172 8.2827 18.5 18.5 18.5z"
          fill="#fff"
        />
        <path
          d="m108.5 93.002c9.665 0 17.5-7.8351 17.5-17.5 0-9.665-7.835-17.5-17.5-17.5s-17.5 7.835-17.5 17.5c0 9.6649 7.835 17.5 17.5 17.5z"
          stroke="#054b54"
          strokeWidth={2}
        />
        <path
          d="m112.503 80.886c0 1.0994-.437 2.1539-1.214 2.9313-.778.7774-1.832 1.2142-2.932 1.2142-1.099 0-2.153-.4368-2.931-1.2142-.777-.7774-1.214-1.8319-1.214-2.9313"
          stroke="#054b54"
          strokeMiterlimit={10}
          strokeWidth={2}
        />
        <path
          d="m100.39 59.7922s7.166 14.6447 22.715 6.8887c-1.01-3.77-4.578-8.3124-15.314-8.2754-2.49.3316-4.96.7949-7.401 1.3867z"
          fill="#054b54"
        />
        <path
          d="m101.062 60.4528s.619 9.4394-8.8004 9.4394c1.3208-2.8251 3.0387-5.4474 5.1006-7.7871z"
          fill="#054b54"
        />
        <path
          d="m107.999 50.001h-1c-30.3757 0-55 24.6243-55 55 0 30.376 24.6243 55 55 55h1c30.376 0 55-24.624 55-55 0-30.3757-24.624-55-55-55z"
          stroke="#054b54"
          strokeWidth={2}
        />
        <path d="m155 88c7.18 0 13-5.8203 13-13s-5.82-13-13-13-13 5.8203-13 13 5.82 13 13 13z" fill="#f64928" />
        <g stroke="#fff">
          <path
            d="m151.023 76.1681 2.619 2.6179 6.427-6.426"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
          />
          <path d="m114.002 109.822h13.674" strokeWidth={4} />
        </g>
      </g>
    </g>
  </svg>
);
export default Verified;
